import { FC } from "react";
import PageLayout from "@/layout/Page";
import HomeHero from "@/components/HomeHero";
import AffordableHealthCare from "@/components/AffordableHealthCare";
import GetAdvantageCard from "@/components/GetAdvantageCardCTA/GetAdvantageCardCTA";
import DownloadApp from "@/components/DownloadApp";
import ParticipatingPharmacies from "@/components/ParticipatingPharmacies/ParticipatingPharmacies";
import WithTheApp from "@/components/AppAbilitiesSection/WithTheApp";
import YouDeserveABetterRX from "@/components/YouDeserveABetterRX/YouDeserveABetterRX";
import FAQSection from "@/components/FAQSection";

export const Home: FC = () => {
  return (
    <PageLayout>
      <HomeHero />
      <AffordableHealthCare />
      <GetAdvantageCard />
      <ParticipatingPharmacies />
      <DownloadApp />
      <WithTheApp />
      <FAQSection />
      <YouDeserveABetterRX />
    </PageLayout>
  );
};
